// extracted by mini-css-extract-plugin
module.exports = {"outerRoot":"SignInChatWithBoss_outerRoot__o2uUk","signInRoot":"SignInChatWithBoss_signInRoot__FfOPr","header":"SignInChatWithBoss_header__nK3fB"};